import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value };
  }

  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
  };

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ value: props.value || '' });
  }

  handleInputChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmitButton() {
    this.props.onChange(this.state.value);
  }

  render() {
    return (
      <div className="SearchField gecko-ui-material">
        <input
          className="SearchField-input form-control"
          value={this.state.value}
          onChange={this.handleInputChange.bind(this)}
        />
        <button
          className="SearchField-button"
          onClick={this.handleSubmitButton.bind(this)}
        >
          <i className="far fa-search"></i>
        </button>
      </div>
    );
  }
}

export default SearchField;
